// extracted by mini-css-extract-plugin
export default {"Header":"TopVouchersCard_Header__U2cT-","Title":"TopVouchersCard_Title__GnniR"};